import { render, staticRenderFns } from "./Footers.vue?vue&type=template&id=6fd5ea46"
import script from "./Footers.vue?vue&type=script&lang=js"
export * from "./Footers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports